module.exports = __webpack_public_path__ + "front/img/27_11.a10c0208.png";